__turbopack_context__.v({
  "date": "H16Saq_date",
  "header": "H16Saq_header",
  "intro": "H16Saq_intro",
  "item": "H16Saq_item",
  "list": "H16Saq_list",
  "page": "H16Saq_page",
  "text": "H16Saq_text",
  "upcoming": "H16Saq_upcoming" + " " + __turbopack_context__.i(262643)["brandchip"],
  "year": "H16Saq_year",
  "yearTitle": "H16Saq_yearTitle",
});
